import ManagedTable, { ManagedColumn, ManagedColumnExtra, ManagedTableProps } from 'app/common/table/ManagedTable';
import { FlightRegLocation } from 'app/model/CORE';
import React from 'react';
import useWindowDimensions from '../../common/hooks/useWindowDimensions';
import './SlotTable.less';

export class FlightRegulationLocationColumn extends ManagedColumn<FlightRegLocation> {
    constructor(
        header: string,
        width: string,
        getCellValue: (object: FlightRegLocation) => any,
        extra?: ManagedColumnExtra<FlightRegLocation>,
    ) {
        super(header, width, getCellValue, extra);
    }
}

export class StandardFlightRegulationLocationColumn {
    public static readonly REGULATION = new FlightRegulationLocationColumn(
        'REGULATION',
        '15em',
        object => object.regulationId,
    );
    public static readonly REF_LOCATION = new FlightRegulationLocationColumn(
        'REF LOCATION',
        '15em',
        object => object.refLocation.refId,
    );
}

class FlightRegulationLocationTableBase extends ManagedTable<FlightRegLocation> {}

// I have had to adapt ManagedTable so that it accepts a font size.
// VirtualTable that is behind only accepts column width in "px", whereas our column definition is in "em".
// This usually is not a problem when font size is fixed, but in our case, font size depends on the viewport width.
// When the viewport is resized, the new font size is provided to the flight table, that will adapt column width accordingly.
const FlightRegulationLocationTable = (props: ManagedTableProps<FlightRegLocation>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <FlightRegulationLocationTableBase fontSize={fontSize} {...props} />;
};

export default FlightRegulationLocationTable;
